import React from 'react';

import { Button, Container, Typography } from '@material-ui/core';
import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';

import { useRedirectResultStyles } from './styles';

export default ({ workspaceCanRequestBeforePay = false }) => {
  const classes = useRedirectResultStyles();
  const history = useHistory();
  const { search } = useLocation();
  const { studyId } = queryString.parse(search);
  const requestQuery = studyId ? `?studyId=${studyId}` : '';
  return (
    <Container className={classes.container}>
      <Container>
        <Typography variant="h6" className={classes.title}>
          Thank you for your payment
        </Typography>
      </Container>

      {!workspaceCanRequestBeforePay ? (
        <>
          <Container className={classes.container1} style={{ width: '32%' }}>
            <Typography variant="subtitle1" className={classes.subtitle}>
              You can now continue to submit your personalized video report request below.
            </Typography>
          </Container>
          <Container className={classes.container2}>
            <Button variant="contained" color="primary" onClick={() => history.push(`/personalized-video${requestQuery}`)}>
              Get personalized video report
            </Button>
          </Container>
        </>
      ) : null}

      <Container className={classes.container3}>
        <Typography className={classes.subtitle2}>
          <a href="#" className={classes.link} onClick={() => history.push('/patient-dashboard')}>
            Go to your personal medical record
          </a>
        </Typography>
      </Container>
    </Container>
  );
};
